import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

export type ReviewedPricingScheduleAcceptanceRow =
  Database["public"]["Tables"]["reviewed_pricing_schedule_acceptances"]["Row"];

export const useReviewedPricingSchedule = (
  userId?: string | null,
  enabled = true,
) =>
  useQuery<ReviewedPricingScheduleAcceptanceRow | null>({
    queryKey: ["reviewed-pricing-schedule", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("reviewed_pricing_schedule_acceptances")
        .select("*")
        .eq("user_id", userId!)
        .order("accepted_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error && error.code !== "PGRST116") throw error;
      return data ?? null;
    },
    enabled: Boolean(userId) && enabled,
  });
